import { createStore } from "vuex";
import currencyModule from './modules/currency';//引入模块
import configModule from './modules/config';//引入模块;
import rulesModule from './modules/rules';//引入模块
import templateModule from './modules/template';//引入模块
export default createStore({
  modules: {
    currency: currencyModule, //添加模块  currency为模块命名空间自动注册路径
    config: configModule, //配置文件
    template: templateModule, //模板管理页面
    rules: rulesModule, //校验规则
  },
  state: {
    loadingStatus: false, //全局loading状态
    newMessages: [],//用户的未读信息
    userInfo: {}, //用户信息
    sideBarApp: [], //侧边栏涉及的其他app名字和路径
    isLogin: false, //是否登录过如果没有就先跑登录等几个接口
    lng: 116.404,
    lat: 39.915,
    batchStyle: 'middle',
    searchFlagAdd: 0,
  },
  mutations: {
    searchFlagAdd(state) {
      state.searchFlagAdd++
    },
    changeNewMessages(state, newMessages) {
      state.newMessages = newMessages;
    },
    changeUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    changeSideBarApp(state, sideBarApp) {
      state.sideBarApp = sideBarApp;
    },
    changeisLogin(state, isLogin) {
      state.isLogin = isLogin;
    },
    changeloadingStatus(state, loadingStatus) {
      state.loadingStatus = loadingStatus;
    },
    changelng(state, lng) {
      state.lng = lng;
    },
    changelat(state, lat) {
      state.lat = lat;
    },
  },
  actions: {},

});
